// import { observer } from "mobx-react"
import React from 'react';

import { I18nContent, WorkRoleScoreRange } from '../../../adl-gen/totalinteraction/futurefit/db';
import { withI18n, WithI18nProps } from '../../../internationalization/i18n-hoc';
import { i18next } from '../../../internationalization/i18next';
import { SliderMarks, StandardSlider } from '../../widgets/slider/slider';

interface ScoreSliderProps extends WithI18nProps {
  ranges: WorkRoleScoreRange[];
  onChange(value: number): void;
  value?: number;
  halfwayMarks?: boolean;
  noZero?: boolean;
}

interface InitSliderProps {
  min: number;
  max: number;
  step?: number | null;
  marks: SliderMarks;
  // init: number|undefined
}

interface CalcMarks {
  mid: number;
  top: number;
  label: I18nContent;
}

/// This includes 'mid' for use when the mid-range of a score range is used to set the expected value;
/// however, at present we are using the top-end only, and setting zero to the mark 'N/A'
const calcMarks = (item: WorkRoleScoreRange): CalcMarks => {
  return {
    mid: Number(((item.scoreRange.range.v2 - item.scoreRange.range.v1) / 2).toFixed(1)) + item.scoreRange.range.v1,
    top: item.scoreRange.range.v2,
    label: item.scoreRange.label
  };
};

class ScoreSlider0 extends React.Component<ScoreSliderProps> {
  sliderProps?: InitSliderProps;

  constructor(props: Readonly<ScoreSliderProps>) {
    super(props);
    this.sliderProps = this.initSlider(props.ranges.slice());
  }

  initSlider = (
    ranges: WorkRoleScoreRange[]
    // value?: number
  ): InitSliderProps | undefined => {
    const { halfwayMarks, noZero, t } = this.props;
    if (ranges.length === 0) {
      return undefined;
    }
    const sortedRanges = ranges.sort((a, b) => a.scoreRange.range.v2 - b.scoreRange.range.v2);
    const min = sortedRanges[0].scoreRange.range.v1;
    const max = sortedRanges[sortedRanges.length - 1].scoreRange.range.v2;
    /// step: Was using to set half-way marks at the centre of the range, but
    /// this does not work if ranges are incongruent, and also where the steps
    /// don't align with the marks. To avoid this, don't use 'step'; instead,
    /// where required just use the midpoints as calculated in calcMarks but
    /// with a blank label. Not ideal when ranges are incongruent but wth
    // const step = +((max - min)/sortedRanges.length/2).toFixed(1)
    const step = null;
    const baseMark: SliderMarks = noZero ? {} : { 0: i18next.t('na', 'N/A') };
    // Extract and sort
    const marks: SliderMarks = sortedRanges.map(calcMarks).reduce((acc: SliderMarks, next) => {
      if (halfwayMarks) {
        acc[next.mid] = ' ';
      }
      acc[next.top] = t(next.label);
      return acc;
    }, baseMark);
    return { min, max, marks, step };
  };

  render() {
    if (this.sliderProps) {
      return <StandardSlider {...this.sliderProps} value={this.props.value} onChange={this.props.onChange} />;
    } else {
      return null;
    }
  }
}

export const ScoreSlider = withI18n(ScoreSlider0);



// WEBPACK FOOTER //
// ./src/ui/components/slider/score-slider.tsx